export default class ItemWrong extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'sprite', 'game/items/stone.png');
    this.setOrigin(0.5);
  }
}
